// Station identity: displayName is the optional, explicitly entered name;
// number and address are independent. Keep legacy `name` readable, but never
// assume that free text such as "Main Hall" is a station number. Editors keep
// legacy `name` intact because some older records reference it; render through
// these helpers rather than reading it directly.
const cleanStationValue = value => String(value ?? '').trim();

const stationAddressText = address => {
    if (typeof address === 'string') return cleanStationValue(address);
    return cleanStationValue(address?.description || address?.formattedAddress);
};

// Only infer a number from unambiguous legacy labels. Other legacy text stays
// a name. Explicit numbers may contain letters (e.g. A1).
const legacyNumber = value => {
    const match = cleanStationValue(value).match(/^(?:Station\s+)?(\d+[a-z]?)$/i);
    return match ? match[1] : '';
};

const stationNumber = station => {
    if (station?.number !== undefined) {
        const number = cleanStationValue(station.number);
        // The old onboarding/editor copied names into `number` too.
        if (station.displayName === undefined && number === cleanStationValue(station.name) && !legacyNumber(number)) {
            return '';
        }
        return number.replace(/^Station\s+/i, '');
    }
    return legacyNumber(station?.name);
};

const stationName = station => {
    // An explicit empty displayName means the name was deliberately cleared.
    if (station?.displayName !== undefined) return cleanStationValue(station.displayName);
    const name = cleanStationValue(station?.name);
    if (legacyNumber(name) || name === stationAddressText(station?.address)) return '';
    return name;
};

const stationDisplayName = station => {
    const name = stationName(station);
    if (name) return name;
    const number = stationNumber(station);
    return number ? `Station ${number}` : 'Station';
};

module.exports = {
    cleanStationValue,
    stationAddressText,
    stationName,
    stationNumber,
    stationDisplayName
};
